export default "__VITE_ASSET__2031115a__"